import { useEffect, useState } from 'react';
import { linkDosPais, textoDoConvite } from '../utils';

interface Props {
  eventoId: number;
}

// O endereço que a direção manda no WhatsApp para os pais preencherem.
export default function CardLink({ eventoId }: Props) {
  const [copiado, setCopiado] = useState(false);
  const link = linkDosPais(eventoId);

  useEffect(() => {
    if (!copiado) return;
    const t = setTimeout(() => setCopiado(false), 3000);
    return () => clearTimeout(t);
  }, [copiado]);

  async function copiar() {
    try {
      await navigator.clipboard.writeText(link);
      setCopiado(true);
    } catch {
      setCopiado(false);
    }
  }

  // wa.me sem telefone: abre a escolha de contato no WhatsApp.
  const linkWa = `https://wa.me/?text=${encodeURIComponent(textoDoConvite(eventoId))}`;

  return (
    <section className="rounded-2xl border border-background-200 bg-white p-4">
      <p className="text-[12px] font-bold uppercase tracking-wide text-foreground-500">
        Link para os pais
      </p>
      <p className="mt-1 break-all text-[13px] leading-relaxed text-foreground-800">{link}</p>

      <div className="mt-3 flex flex-col gap-2 sm:flex-row">
        <button
          type="button"
          onClick={copiar}
          className="flex h-12 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-2xl border border-background-300 bg-white px-4 text-[14px] font-semibold text-foreground-800 transition-colors hover:bg-background-100 sm:w-auto"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className={copiado ? 'ri-check-line' : 'ri-file-copy-line'} aria-hidden />
          </span>
          {copiado ? 'Link copiado' : 'Copiar link'}
        </button>

        <a
          href={linkWa}
          target="_blank"
          rel="noopener noreferrer"
          className="flex h-12 w-full cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-2xl bg-success-600 px-4 text-[14px] font-semibold text-white transition-colors hover:bg-success-700 sm:w-auto"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-whatsapp-line text-lg" aria-hidden />
          </span>
          Mandar no WhatsApp
        </a>
      </div>

      <p className="mt-2 text-[12px] leading-relaxed text-foreground-500">
        O pai ou a mãe entra com CPF e data de nascimento, sem baixar nada.
      </p>
    </section>
  );
}